<script setup >
import { inject } from 'vue'
import  { replaceS3path } from '@/Shared/helper.js'

const data = inject('data')
</script>

<template>
  <div class="brand-visual">
    <div class="visual">
      <div class="cover" />
      <img class="logo" :src="replaceS3path(data.brandThumbL)" :alt="data.brandName" />
    </div>
  </div>
</template>
